import React from "react";
import About1 from "../About/About1";

import WhyChoose from "../Home/WhyChoose";
import Ourservices from "../About/Ourservices";

function About() {
  return (
    <div>
      <About1 />
      <WhyChoose />
      <Ourservices />
    </div>
  );
}

export default About;
